import React, { useState } from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom/dist";

import Arrow from "../../pages/Arrow";
import Generalsidebar from "../../pages/Generalsidebar";

const VideoMain = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  function handleArrowClick() {
    setShowSidebar(true);
  }
  const videos = [
    {
      image:
        "https://res.cloudinary.com/dzqx4v0al/image/upload/v1702591147/young-depressed-adult-home_ffodnr.jpg",
      title: "WHY SO LONELY?",
      content:
        "Remember, loneliness is a transient emotion - it ebbs and flows. Embrace solitude as a chance to reconnect with yourself and explore the depths of your thoughts and dreams. Ultimately, by fostering...",
      link: "/lonely",
    },
    {
      image:
        "https://res.cloudinary.com/dzqx4v0al/image/upload/v1702591147/young-depressed-adult-home_1_faj3ev.jpg",
      title: "COMBATING DEPRESSION",
      content:
        "The power of friendship is a profound and transformative force that plays a crucial role in shaping our lives and well-being. Friendships are not merely social connections; they are dynamic...",
      link: "/poweroftwo",
    },
    {
      image:
        "https://res.cloudinary.com/dzqx4v0al/image/upload/v1702591147/horizontal-shot-beautiful-dark-skinned-female-with-cheerful-expression-happy-meet-her-best-african-american-friend-sit-outdoor-cafe_gj7aml.jpg",
      title: "THE POWER OF TWOS",
      content:
        "The power of friendship is a profound and transformative force that plays a crucial role in shaping our lives and well-being. Friendships are not merely social connections; they are dynamic...",
      link: "/depression",
    },

    // Add more videos as needed
  ];

  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = videos
    .filter((video) =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    videos.filter((video) =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase())
    ).length / itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div className="text-black ml-20 mt-2">
        <Link to="/mainresources">
          <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>
      </div>
      <div className="mx-auto max-w-[900px] my-5 p-10 rounded-lg shadow-inner shadow-black">
        <div className="mx-10">
          <h1 className="text-3xl text-[#295700] font-serif font-bold py-5 text-center">
            OUR VIDEOS
          </h1>
          <div className="flex justify-center mb-4">
            <input
              type="text"
              placeholder="Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border p-2 mr-2"
            />
            <button
              onClick={() => {
                setCurrentPage(1); // Reset page when search term changes
              }}
              className="bg-[#295700] text-white px-4 py-2 rounded  hover:bg-green-700"
            >
              Search
            </button>
          </div>
        </div>
        <div className="bg-[#DCAE96] px-4 py-4 text-center">
          {currentItems.map((video, index) => (
            <div key={index} className="mb-8">
              <img
                src={video.image}
                alt={`video ${index + 1}`}
                className="w-[50%] ml-[200px] mb-4 text-center"
              />
              <div>
                <h2 className="text-xl text-[#295700] font-serif font-bold mb-2">
                  {video.title}
                </h2>
                <p>{video.content}</p>
              </div>
              <div className="mt-4">
                <Link to={video.link}>
                  <button className="border-2 border-[#295700] px-5 py-1 rounded-xl hover:bg-[#295700] hover:text-white">
                    Watch Video
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center m-8">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (pageNumber) => (
              <button
                key={pageNumber}
                onClick={() => handlePageChange(pageNumber)}
                className="mx-2 px-3 py-1 border border-[#295700] rounded-full"
              >
                {pageNumber}
              </button>
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default VideoMain;
